
import React from 'react';

interface UserStatsProps {
  avgEmotion: number | null;
  counselingCount: number | null;
  consecutiveDays: number | null;
  isDownloading: boolean;
  handleDownloadReport: () => void;
}

const UserStats: React.FC<UserStatsProps> = ({ 
  avgEmotion,
  counselingCount,
  consecutiveDays,
  isDownloading,
  handleDownloadReport 
}) => {
  return (
    <section className="setting-section stats-section">
      <div className="section-header">
        <h2>나의 활동 요약</h2>
      </div>
      <div className="stats-grid">
        <div className="stat-card">
          <h4>마음 온도 평균</h4>
          <p>{avgEmotion !== null ? `${avgEmotion}°` : '-'}</p>
        </div>
        <div className="stat-card">
          <h4>총 리본상담 횟수</h4>
          <p>{counselingCount !== null ? `${counselingCount}회` : '-'}</p>
        </div>
        <div className="stat-card">
          <h4>연속 기록 일수</h4>
          <p>{consecutiveDays !== null ? `${consecutiveDays}일` : '-'}</p>
        </div>
        <div className="stat-card">
          <h4>종합 결과</h4>
          <button
            onClick={handleDownloadReport}
            className="download-btn"
            disabled={isDownloading}
          >
            {isDownloading ? '생성 중...' : 'PDF 다운로드'}
          </button>
        </div>
      </div>
    </section>
  );
};

export default UserStats;
